/**
 * The case courts come from the server (whose court a case is in follows
 * its oldest open ask), but the door's case list is polled every 30 s while
 * the asks change the moment one is sent. UX round 2026-10-27: ten seconds
 * after an ask to Ashton went out, the Cases board said "Waiting on people
 * 1: Ashton, INV-00004" above an INV-00004 card still in "Our court" saying
 * nobody had been asked. The door re-reads the case list whenever the set of
 * open asks changes, so both read the same moment.
 */
import { useEffect, useRef } from 'react';

import { isWaitingAsk } from '../../components/quality/askKind';
import type { DoorDataRequestRead } from '../../services/qcpDataRequests';

/** One string per set of open asks and the case each is on: it changes
 *  when an ask is sent, answered, withdrawn or moved to another case. */
export function openAskKey(
  requests: ReadonlyArray<Pick<DoorDataRequestRead, 'id' | 'status' | 'investigation_id'> & Partial<Pick<DoorDataRequestRead, 'kind'>>>,
): string {
  return requests
    .filter(isWaitingAsk)
    .map((r) => `${r.id}:${r.investigation_id ?? ''}`)
    .sort()
    .join(',');
}

/** Re-read the case list when the open asks change (never on the first
 *  render: the list was just fetched then). */
export function useRefreshCasesOnAskChange(key: string, refresh: () => void): void {
  const last = useRef<string | null>(null);
  useEffect(() => {
    if (last.current !== null && last.current !== key) refresh();
    last.current = key;
  }, [key, refresh]);
}
